// extracted by mini-css-extract-plugin
module.exports = {"synopsis":"-R-O-0","atfSynopsis":"_1npiSz"};